import { useMutation } from '@tanstack/react-query';

import { AddInstConnectPageData, InstPage } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';

export const addInstConnectPage = (
  data: AddInstConnectPageData
): Promise<{ pages: InstPage[] }> => {
  return axios.post(`/meta/pages/add-instagram-connect`, data);
};

type AddInstConnectPageOptions = {
  config?: MutationConfig<typeof addInstConnectPage>;
};

export function useAddInstConnectPage({ config = {} }: AddInstConnectPageOptions = {}) {
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(['pages']);
    },
    ...config,
    mutationFn: addInstConnectPage,
  });
}
